import React from "react";

export default function AdminProductList({ 
  products, 
  loading, 
  error, 
  onEdit, 
  onDelete, 
  onRetry 
}) {
  return (
    <div className="bg-raya-card rounded-lg p-6 border border-raya-border shadow-sm">
      <h2 className="text-2xl font-bold mb-6">
        Products ({products.length})
      </h2>

      {loading ? (
        <p className="text-raya-text-secondary">Loading products...</p>
      ) : error ? (
        <div className="text-center py-4">
           <p className="text-raya-text-tertiary mb-2">Error loading products: {error}</p>
           <button onClick={onRetry} className="text-raya-accent hover:underline">Try Again</button>
        </div>
      ) : products.length === 0 ? (
        <p className="text-raya-text-secondary">No products yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-raya-border">
                <th className="text-left py-3 px-4">Image</th>
                <th className="text-left py-3 px-4">Name</th>
                <th className="text-left py-3 px-4">Price</th>
                <th className="text-left py-3 px-4">Stock</th>
                <th className="text-left py-3 px-4">Description</th>
                <th className="text-left py-3 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => {
                if (!product) return null;
                return (
                <tr
                  key={product.id}
                  className="border-b border-raya-border hover:bg-raya-bg-off"
                >
                  <td className="py-4 px-4">
                    {product.image ? (
                      <img
                        src={product.image}
                        alt={product.name}
                        className="h-16 w-16 object-cover rounded border border-raya-border"
                      />
                    ) : (
                      <div className="h-16 w-16 bg-raya-bg-off rounded flex items-center justify-center text-raya-text-tertiary border border-raya-border">
                        No image
                      </div>
                    )}
                  </td>
                  <td className="py-4 px-4 font-semibold">{product.name}</td>
                  <td className="py-4 px-4">${parseFloat(product.price).toFixed(2)}</td>
                  <td className="py-4 px-4">
                    <span className={`font-semibold ${product.quantity > 0 ? 'text-raya-accent' : 'text-raya-text-tertiary'}`}>
                      {product.quantity || 0}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-sm text-raya-text-secondary">
                    {product.description}
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex gap-2">
                      <button
                        onClick={() => onEdit(product)}
                        className="bg-raya-accent hover:bg-raya-accent-hover text-black px-3 py-1 rounded text-sm font-semibold transition"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => onDelete(product.id)}
                        className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm transition"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
